import autocomplete from './autocomplete';
import type { Epic } from './common';
import fitmentSearch from './fitmentSearch/index';
import htmxEvent from './htmxEvent';
import localStorage from './localStorage';
import redirect from './redirect';
import requestScroll from './requestScroll';
import retrySearch from './retrySearch';
import search from './search/index';

function named(name: string, epic: Epic): Epic {
  Object.defineProperty(epic, 'name', { value: name, configurable: true });
  return epic;
}

const epics = [
  redirect,
  requestScroll,
  named('autocomplete', autocomplete),
  named('search', search),
  localStorage,
  htmxEvent,
  named('retrySearch', retrySearch),
  fitmentSearch,
].flat();

export default epics;
